import React, { FC } from "react";

import { CustomImageType, InternalType, LinkType } from "@bared/groq";

import { type ComponentProps, type FromSanityGraphQL } from "@ts/components";
import { SectionImage } from "@ts/sanity";

export type ImageProps = ComponentProps &
  FromSanityGraphQL<SectionImage> & {
    imageLink: LinkType | InternalType;
    mobileImageLink: LinkType | InternalType;
  };

export type ImageOutputProps = Omit<ImageProps, "image"> & {
  image: CustomImageType;
};

export const withImage =
  (Component: FC<ImageProps>) =>
  ({ name = "Image", analytics, ...props }: ImageProps) => {
    const { image, mobileImage } = props;
    const imageLink = image && image.imagelink ? image.imagelink[0] : null;
    const mobileImageLink =
      mobileImage && mobileImage.imagelink ? mobileImage.imagelink[0] : null;

    Component.displayName = name;

    return (
      <Component
        {...props}
        image={image}
        imageLink={imageLink}
        mobileImage={mobileImage}
        mobileImageLink={mobileImageLink}
      />
    );
  };
